(function() {
  "use strict";

  angular
    .module("app")
    .directive("cccCommunityDataTable", cccCommunityDataTable);

  function cccCommunityDataTable() {
    return {
      restrict: "EA",
      scope: false,
      controller: "CommunityDataTableController"
    };
  }
})();
